<div
  class="panel"
  [class.rs-bg-grey2]="greyBackground"
  data-cy="fiberMigration"
  data-tms-event="card-click-impression"
  data-tms-card-zone="product overview"
  data-tms-card-name="fiber box"
>
  <div class="rs-flex-row rs-flex-collapse">
    <div class="rs-flex-column rs-flex-shrink">
      <p class="rs-padding-bottom1">
        <i
          class="icon-Fiber icon-lh rs-txt-s7 rs-txt-purple rs-margin-right1"
          aria-hidden="true"
        ></i>
      </p>
    </div>
    <div class="rs-flex-column">
      <h2 class="rs-tit5" data-cy="fiberMigrationTitle">
        {{ "products.overview.fiberMigration.title" | translate }}
      </h2>
    </div>
  </div>
  <p data-cy="fiberMigrationDescription">
    {{ "products.overview.fiberMigration.label" | translate }}
  </p>
  <button
    class="rs-btn"
    (click)="onClick()"
    data-cy="fiberMigrationLink"
    data-tms-event="link-click"
    data-tms-link-zone="product overview"
    [attr.data-tms-link-name]="
      'products.overview.fiberMigration.button' | translate
    "
  >
    {{ "products.overview.fiberMigration.button" | translate }}
  </button>
</div>
